// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"BY-z"};